import React from 'react';
import ReactDOM from 'react-dom/client';
import axios from 'axios';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import { cargarApiBaseUrl } from './services/apiConfig';

// Modo mantenimiento: cualquier respuesta 503 (perfil 1 activó el modo
// mantenimiento desde Configuración > Facturación) desloguea acá mismo,
// para cualquier pantalla/perfil, sin tener que agregar este chequeo en
// cada componente que llama a la API.
axios.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error?.response?.status === 503) {
      sessionStorage.clear();
      window.location.href = '/login?mantenimiento=1';
      // Promise que nunca resuelve: evita que el .catch() del componente que
      // hizo el pedido original llegue a mostrar su propio error de golpe,
      // justo cuando ya estamos navegando afuera de esa pantalla.
      return new Promise(() => {});
    }
    return Promise.reject(error);
  }
);

const root = ReactDOM.createRoot(document.getElementById('root'));

// Esperamos a resolver /config.json (API de esta franquicia) ANTES de
// renderizar — así ningún componente llega a leer API_BASE_URL vacío.
// .finally() asegura que la app arranca igual aunque config.json falle.
cargarApiBaseUrl().finally(() => {
  root.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );
});

// Registra el service worker mínimo (sin caching) para que el navegador
// ofrezca instalar la app como PWA.
serviceWorkerRegistration.register();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
